export default {"src":"/_next/static/media/loading.76f1dadc.svg","height":200,"width":200};